<section class="vm-row" [id]="data?.id">
  <h2 *ngIf="data?.title">
    {{ data?.title }}
  </h2>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy"></vm-markdown>
  <vm-accordion>
    <vm-accordion-item [isActive]="accordion?.isActive" *ngFor="let accordion of data?.items">
      <vm-accordion-title-bar
        [icon]="accordion?.icon"
        (click)="onContentClicked('accordion', { content_name: data?.title, content_text: accordion?.title })"
        >{{ accordion?.title }}</vm-accordion-title-bar
      >
      <vm-markdown *ngIf="accordion?.copy" [data]="accordion?.copy"></vm-markdown>
    </vm-accordion-item>
  </vm-accordion>
</section>
